routes.$inject = ['$routeProvider'];

export default function routes($routeProvider) {
  $routeProvider
    .when('/verify', {
      template: require('./verify.html'),
      controller: 'VerifyCtrl',
      reloadOnSearch: false,
      app: true,
      resolve: {
        verifiedUser: ['CurrentUser', '$route', '$q', '$location',
          'ReloadServ',
          function (CurrentUser, $route, $q, $location, ReloadServ) {
            var v = $q.defer();
            CurrentUser.api.get().then(() => {
              if (CurrentUser.data.verified) {
                // if user is verified, redirect user if path is passed
                // or just display verified page
                if ($route.current.params.path) {
                  $location.url($route.current.params.path);
                } else {
                  v.resolve(CurrentUser);
                }
              } else if ($route.current.params.token) {
                // if user has token, attempt verification, 
                // on success, redirect user if path passed or
                // just display verified page
                CurrentUser.api.verify({
                  token: $route.current.params.token
                }, () => {
                  ReloadServ.updateTabs();
                  if ($route.current.params.path) {
                    $location.path($route.current.params.path);
                  } else {
                    v.resolve(CurrentUser);
                  }
                }, () => {
                  v.resolve({
                    error: 'account'
                  });
                });
              } else {
                v.resolve({
                  error: 'token'
                });
              }
            });
            return v.promise;
          }
        ]
      }
    });
}



// WEBPACK FOOTER //
// ./project/pages/verify/verify.routes.js